import React, {useEffect, useState} from 'react'

interface TimeoutRenderProps {
  children: React.ReactElement
  timeout: number
  callback?: () => void
}

export const TimeoutRender = ({
  children,
  timeout,
  callback
}: TimeoutRenderProps) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!children) {
      callback?.()
      return undefined
    }

    const dispose = setTimeout(() => {
      setShow(true)
      callback?.()
    }, timeout)

    return () => clearTimeout(dispose)
  }, [])

  return show ? children : null
}
